import { dcAuthApi } from '../apiBase';
import type { AdminScope } from '../../types/adminScope';

interface AdminScopeDto {
  is_platform_admin: boolean;
  managed_tenant_ids: string[];
  can_access_dc_admin: boolean;
}

function mapAdminScope(dto: AdminScopeDto): AdminScope {
  return {
    isPlatformAdmin: dto.is_platform_admin,
    managedTenantIds: dto.managed_tenant_ids,
    canAccessDcAdmin: dto.can_access_dc_admin,
  };
}

export const adminScopeApi = {
  async getMyScope(): Promise<AdminScope> {
    const response = await dcAuthApi.get<AdminScopeDto>('/users/me/admin-scope');
    return mapAdminScope(response.data);
  },
};
